import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "flex flex-col"
};
const _hoisted_2 = {
  class: "flex-auto flex overflow-hidden"
};
import songCard from './songCard/index.vue';
import songInfo from './songInfo/index.vue';
import audioBar from './audioBar/index.vue';
import { provide, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'Index'
  },
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    const currentType = ref('mine');
    // loading 状态
    const loading = ref(false);
    // 当前音乐
    const currentSong = ref({});
    const mySongList = ref([]);
    const squareSongList = ref([]);
    provide('currentSong', currentSong);
    /*
     *@Description: 调接口生成音乐列表
     *@MethodAuthor: xiaohong
     *@Date: 2024-06-27 17:06:44
    */
    function generateMusic(formData) {
      console.log(formData);
      loading.value = true;
      setTimeout(() => {
        mySongList.value = Array.from({
          length: 20
        }, (_, index) => {
          return {
            id: index,
            audioUrl: '',
            videoUrl: '',
            title: '我走后' + index,
            imageUrl: 'https://www.carsmp3.com/data/attachment/forum/201909/19/091020q5kgre20fidreqyt.jpg',
            desc: 'Metal, symphony, film soundtrack, grand, majesticMetal, dtrack, grand, majestic',
            date: '2024年04月30日 14:02:57',
            lyric: `<div class="_words_17xen_66"><div>大江东去，浪淘尽，千古风流人物。
          </div><div>故垒西边，人道是，三国周郎赤壁。
          </div><div>乱石穿空，惊涛拍岸，卷起千堆雪。
          </div><div>江山如画，一时多少豪杰。
          </div><div>
          </div><div>遥想公瑾当年，小乔初嫁了，雄姿英发。
          </div><div>羽扇纶巾，谈笑间，樯橹灰飞烟灭。
          </div><div>故国神游，多情应笑我，早生华发。
          </div><div>人生如梦，一尊还酹江月。</div></div>`
          };
        });
        loading.value = false;
      }, 3000);
    }
    /*
     *@Description: 设置当前播放的音乐
     *@MethodAuthor: xiaohong
     *@Date: 2024-07-19 11:22:33
    */
    function setCurrentSong(music) {
      currentSong.value = music;
    }
    __expose({
      generateMusic
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_tabs, {
        modelValue: currentType.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => currentType.value = $event),
        class: "flex-auto px-[var(--app-content-padding)]"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
          label: "我的创作",
          name: "mine"
        }, {
          default: _withCtx(() => [mySongList.value.length ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            gutter: 12
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mySongList.value, song => {
              return _openBlock(), _createBlock(_component_el_col, {
                key: song.id,
                span: 24
              }, {
                default: _withCtx(() => [_createVNode(songCard, {
                  songInfo: song,
                  onPlay: $event => setCurrentSong(song)
                }, null, 8, ["songInfo", "onPlay"])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "暂无音乐"
          }))]),
          _: 1
        })), [[_directive_loading, loading.value]]), _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
          label: "试听广场",
          name: "square"
        }, {
          default: _withCtx(() => [squareSongList.value.length ? _withDirectives((_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            gutter: 12
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(squareSongList.value, song => {
              return _openBlock(), _createBlock(_component_el_col, {
                key: song.id,
                span: 24
              }, {
                default: _withCtx(() => [_createVNode(songCard, {
                  songInfo: song,
                  onPlay: $event => setCurrentSong(song)
                }, null, 8, ["songInfo", "onPlay"])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })), [[_directive_loading, loading.value]]) : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "暂无音乐"
          }))]),
          _: 1
        })), [[_directive_loading, loading.value]])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(songInfo, {
        class: "flex-none"
      })]), _createVNode(audioBar, {
        class: "flex-none"
      })]);
    };
  }
});